import { Autocomplete, Box, TextField } from '@mui/material';
import { WEIGHT_UNITS } from '../../../common/weightFormat';
import { formatNumberValue } from '../../../common/numberFormat';

const WeightConfiguration = ({ config, onChange }) => {
  const previewConfig = {
    ...config,
    decimal_places:
      config.decimal_places === '' || config.decimal_places === undefined
        ? undefined
        : Number(config.decimal_places)
  };
  return (
    <>
      <Autocomplete
        options={WEIGHT_UNITS}
        groupBy={(unit) => unit.system}
        value={
          WEIGHT_UNITS.find(({ value }) => value === config.weight_unit) || null
        }
        getOptionLabel={({ label, symbol }) => label + ' — ' + symbol}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        onChange={(_, unit) =>
          onChange({
            target: { name: 'weight_unit', value: unit?.value || '' }
          })
        }
        renderInput={(params) => (
          <TextField {...params} margin="dense" label="Weight Unit" />
        )}
      />
      <Box mt={1}>
        Preview: <bdi>{formatNumberValue(1234.56, previewConfig)}</bdi>
      </Box>
      <Box mt={1}>
        Changing the weight unit relabels existing values without converting
        amounts.
      </Box>
    </>
  );
};

export default WeightConfiguration;
